import React from "react";

const ClockIco = () => {
    return (
        <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.4925 0.0429688C3.3525 0.0429688 0 3.40297 0 7.54297C0 11.683 3.3525 15.043 7.4925 15.043C11.64 15.043 15 11.683 15 7.54297C15 3.40297 11.64 0.0429688 7.4925 0.0429688ZM10.5 10.543C10.4306 10.6125 10.3482 10.6677 10.2575 10.7053C10.1667 10.7429 10.0695 10.7623 9.97125 10.7623C9.87302 10.7623 9.77576 10.7429 9.68503 10.7053C9.5943 10.6677 9.51189 10.6125 9.4425 10.543L6.975 8.07547C6.90413 8.00601 6.84776 7.92317 6.80913 7.83177C6.77051 7.74036 6.75041 7.6422 6.75 7.54297V4.54297C6.75 4.13047 7.0875 3.79297 7.5 3.79297C7.9125 3.79297 8.25 4.13047 8.25 4.54297V7.23547L10.5 9.48547C10.7925 9.77797 10.7925 10.2505 10.5 10.543Z"
                fill="#FF5487"
            />
        </svg>
    );
};

export default ClockIco;
